import { useAppDispatch, useAppSelector } from 'app/hooks';
import styles from './ThumbnailSidebar.module.css';
import { Box, Grid, IconButton, Typography, Tooltip } from '@mui/material';
import { CloseRounded } from '@mui/icons-material';
import { Page, toggleSidebar } from 'features/document/documentSlice';
import { FC, MutableRefObject, RefObject, useState } from 'react';
import Thumbnail from '../Thumbnail/Thumbnail';

interface Props {
  pages: Page[];
  thumbnailPagesRef: MutableRefObject<RefObject<HTMLDivElement>[]>;
  scrollToPage: (pageIndex: number, fromThumbnail: boolean) => void;
}

const ThumbnailSidebar: FC<Props> = ({ pages, thumbnailPagesRef, scrollToPage }) => {
  const selector = useAppSelector;
  const dispatch = useAppDispatch();
  const isSidebarOpen = selector(state => state.document.isSidebarOpen);
  const [selectedThumbnail, setSelectedThumbnail] = useState(-1);

  const handleCloseSidebar = () => {
    dispatch(toggleSidebar());
  };

  const handleThumbnailClick = (pageIndex: number) => {
    setSelectedThumbnail(pageIndex);
    scrollToPage(pageIndex, true);
  };

  return (
    <Grid item xs={2} className={`${styles.sidebar} ${isSidebarOpen ? styles.sidebarOpen : styles.sidebarClosed}`}>
      <div className={styles.sidebarTitle}>
        <Typography fontSize={'16px'} fontWeight={'500'}>
          Page Thumbnails
        </Typography>
        <Tooltip title='Close' arrow>
          <IconButton onClick={handleCloseSidebar}>
            <CloseRounded color='primary' />
          </IconButton>
        </Tooltip>
      </div>
      <Box
        className={styles.sidebarContent}
        sx={{
          overflowY: 'auto',
        }}
      >
        {pages.map((page: Page, index) => (
          <Grid
            className={`${styles.thumbnail} ${index === selectedThumbnail && styles.selectedThumbnail}`}
            item
            container
            key={page.id}
            ref={thumbnailPagesRef.current[index]}
            onClick={() => handleThumbnailClick(index)}
          >
            <Box
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                height: '100%',
                width: '100%',
                cursor: 'pointer',
                opacity: 0,
                zIndex: 10,
              }}
            />
            <Grid item xs={3} className={styles.thumbnailIndex}>
              {index + 1}
            </Grid>
            <Grid className={styles.thumbnailContainer} item xs={9}>
              <Thumbnail content={page} pageNumber={index + 1} totalPages={pages.length} />
            </Grid>
          </Grid>
        ))}
      </Box>
    </Grid>
  );
};

export default ThumbnailSidebar;
